module.exports = __webpack_public_path__ + "img/logo-instagram.2413ceef.svg";